import { ParseQuery } from './parse-query';
import { Banner } from './../data';

export class BannerQuery extends ParseQuery<Banner> {
  constructor() {
    super(Banner);
  }

  public code(code: string) {
    this.equalTo(Banner.CODE_KEY, code);
    return this;
  }
}





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/banner-query.ts